import app from 'firebase/app';
import 'firebase/analytics';

var firebaseConfig = {
  apiKey: "AIzaSyCSVNjIhUoc5bQNtlgBt0G7CtBu4yNrBBA",
  authDomain: "fir-twigbig.firebaseapp.com",
  databaseURL: "https://fir-twigbig.firebaseio.com",
  projectId: "firebase-twigbig",
  storageBucket: "firebase-twigbig.appspot.com",
  messagingSenderId: "631354353247",
  appId: "1:631354353247:web:54e42a349cac22c1299dea",
  measurementId: "G-NJREJYG6V3"
};

app.initializeApp(
  firebaseConfig
)

//put inside your constructor
app.analytics()


var mixpanel = require('mixpanel-browser');
mixpanel.init("139e514a7dcfc99b67d5bfe261919709");


export async function track(event: string, parameters?: object) {
  console.log(event)
  mixpanel.track(event, parameters);
  app.analytics().logEvent(event, parameters)
}
export async function pageTrack(page: string) {
  app.analytics().setCurrentScreen(page);
}
